// @flow

export const Modes = {
  Admin: 0,
  SectionLeader: 1,
  Denied: -1,
  SignedOut: -2
};

export const Pages = {
  Login: '/',
  SelectEvent: '/select',
  NewEvent: '/new',
  StudentList: '/students',
  Denied: '/denied',
  Admin: '/admin',
  PrivacyPolicy: '/privacy'
};



// WEBPACK FOOTER //
// ./components/appConstants.js